import * as Server from '@/utils/api';

export const toggleMetaRobotsNoIndex = (enable) => {
    const metaRobots = document.querySelector('meta[name="robots"]');

    if (metaRobots === null) {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = enable ? 'noindex' : 'index';
        document.head.appendChild(meta);
    }

    if (metaRobots) {
        metaRobots.content = enable ? 'noindex' : 'index';
    }

    return true;
}

export const setQueryString = (obj) => {
    const str = [];
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            if (typeof obj[p] === 'undefined') {
                continue;
            }
            if (typeof obj[p] === 'object' && obj[p] !== null) {
                obj[p] = btoa(JSON.stringify(obj[p]));
            }
            str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
    }
    if (window.location.search.substring(1) === str.join("&")) {
        return str.join("&");
    }
    window.history.pushState({}, '', window.location.pathname + '?' + str.join("&"));
    return str.join("&");
}

export const queryStringToObject = (parseValues = true, options) => {
    const search = window.location.search.substring(1);
    if (search === '') {
        return false;
    }
    let urlParams = {};
    search.split('&').forEach((param) => {
        const parts = param.split('=');
        let value = decodeURIComponent(parts[1]);
        if (options) {
            options.forEach((option) => {
                if (option.appends && option.appends) {
                    option.appends.forEach((append) => {
                        if (
                            append.key === parts[0] &&
                            value.substring(value.length - append.append.length) != append.append
                            ) {
                            value += append.append;
                        }
                    });
                }
            });
        }
        if (isBase64(value) && parseValues) {
            urlParams[parts[0]] = JSON.parse(atob(value));
            return;
        }
        urlParams[parts[0]] = value;
    });

    return urlParams;
}

export const isBase64 = (str) => {
    let base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    return base64regex.test(str);
}

export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export const getDefaultToolbar = () => {
    return [
        ['bold', 'italic', 'underline'],
        [{ 'header': 1 }, { 'header': 2 }],
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        [{ 'align': [] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        ['link', 'image'],
        ['clean'],
    ];
}

export const setLanguage = (lang) => {
    document.querySelector('html').setAttribute('lang', lang);
    Server.setLanguage(lang);
    localStorage.setItem('lang', lang);
}